// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetIndexAdvisorStatusQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type GetIndexAdvisorStatusQuery = {
  __typename?: "GraphqlQuery";
  getIndexAdvisorStatus: {
    __typename?: "IndexAdvisorStatus";
    id: number;
    analyzedCount: number;
    analyzedWithoutErrors: number;
    processedTables: number;
    totalTables: number;
    lastProcessed?: number | null;
    analyzedQueriesPercentage: number;
    queriesWithErrors: Array<{
      __typename?: "QueryAnalysisError";
      id: number;
      truncatedQuery?: string | null;
      tableNames?: Array<string> | null;
      error: string;
      pctOfTotal: number;
    }>;
    tableStats: Array<{
      __typename?: "QueryAnalysisTableStats";
      id: number;
      tableName: string;
      scansCount?: number | null;
      insightsCount?: number | null;
      failed?: boolean | null;
      lastRun?: number | null;
    }>;
  };
};

export const GetIndexAdvisorStatusDocument = gql`
  query GetIndexAdvisorStatus($databaseId: ID!) {
    getIndexAdvisorStatus(databaseId: $databaseId) {
      id
      analyzedCount
      analyzedWithoutErrors
      processedTables
      totalTables
      lastProcessed
      analyzedQueriesPercentage
      queriesWithErrors {
        id
        truncatedQuery
        tableNames
        error
        pctOfTotal
      }
      tableStats {
        id
        tableName
        scansCount
        insightsCount
        failed
        lastRun
      }
    }
  }
`;

/**
 * __useGetIndexAdvisorStatusQuery__
 *
 * To run a query within a React component, call `useGetIndexAdvisorStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexAdvisorStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexAdvisorStatusQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useGetIndexAdvisorStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIndexAdvisorStatusQuery,
    GetIndexAdvisorStatusQueryVariables
  > &
    (
      | { variables: GetIndexAdvisorStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetIndexAdvisorStatusQuery,
    GetIndexAdvisorStatusQueryVariables
  >(GetIndexAdvisorStatusDocument, options);
}
export function useGetIndexAdvisorStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIndexAdvisorStatusQuery,
    GetIndexAdvisorStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetIndexAdvisorStatusQuery,
    GetIndexAdvisorStatusQueryVariables
  >(GetIndexAdvisorStatusDocument, options);
}
// @ts-ignore
export function useGetIndexAdvisorStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetIndexAdvisorStatusQuery,
    GetIndexAdvisorStatusQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorStatusQuery,
  GetIndexAdvisorStatusQueryVariables
>;
export function useGetIndexAdvisorStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorStatusQuery,
        GetIndexAdvisorStatusQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetIndexAdvisorStatusQuery | undefined,
  GetIndexAdvisorStatusQueryVariables
>;
export function useGetIndexAdvisorStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetIndexAdvisorStatusQuery,
        GetIndexAdvisorStatusQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetIndexAdvisorStatusQuery,
    GetIndexAdvisorStatusQueryVariables
  >(GetIndexAdvisorStatusDocument, options);
}
export type GetIndexAdvisorStatusQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorStatusQuery
>;
export type GetIndexAdvisorStatusLazyQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorStatusLazyQuery
>;
export type GetIndexAdvisorStatusSuspenseQueryHookResult = ReturnType<
  typeof useGetIndexAdvisorStatusSuspenseQuery
>;
export type GetIndexAdvisorStatusQueryResult = Apollo.QueryResult<
  GetIndexAdvisorStatusQuery,
  GetIndexAdvisorStatusQueryVariables
>;
